import { callable } from './callable'

export type TeamSeatSummary = {
  activeMembers: number
  unusedJoinCodes: number
  limit: number
}

export type GetTeamSeatSummaryInput = {
  workspaceId: string
}

export const getTeamSeatSummary = async (
  input: GetTeamSeatSummaryInput,
): Promise<TeamSeatSummary> =>
  callable<GetTeamSeatSummaryInput, TeamSeatSummary>('getTeamSeatSummary', input)
